import React from 'react';
import { Outlet } from 'react-router-dom';
import Header from '../components/common/Header';
import Footer from '../components/common/Footer';
import ErrorBoundary from '../components/common/ErrorBoundary';

const MainLayout: React.FC = () => {
  return (
    <div className="min-h-screen bg-canvas-primary flex flex-col">
      <Header />
      <ErrorBoundary>
        <main className="flex-grow">
          <Outlet />
        </main>
      </ErrorBoundary>
      <Footer />
    </div>
  );
};

export default MainLayout;
